import { LazyQueryHookOptions } from "@apollo/client"

import { useEvent } from "shared/lib/useEvent"

import {
  ProductConfigurationQuery,
  ProductConfigurationQueryVariables,
  useProductConfigurationLazyQuery,
  useProductConfigurationQuery
} from "entities/dim-configuration/graphql/product-configuration.queries.generated"

import { useConfigurationKeyCache } from "./useConfigurationKeyCache"

export function useProductConfigurationQueryWithCache(
  baseOptions: Parameters<typeof useProductConfigurationQuery>[0]
) {
  const updateCache = useConfigurationKeyCache()
  const handleCompleted = useEvent((data: ProductConfigurationQuery) => {
    updateCache(data.productConfiguration)
    baseOptions?.onCompleted?.(data)
  })

  return useProductConfigurationQuery({
    ...baseOptions,
    onCompleted: handleCompleted
  })
}

export function useProductConfigurationQueryWithCacheLazy(
  baseOptions?: LazyQueryHookOptions<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >
) {
  const updateCache = useConfigurationKeyCache()
  const handleCompleted = useEvent((data: ProductConfigurationQuery) => {
    updateCache(data.productConfiguration)
    baseOptions?.onCompleted?.(data)
  })

  return useProductConfigurationLazyQuery({
    ...baseOptions,
    onCompleted: handleCompleted
  })
}
